<template>
    <Layout :style="'min-height:'+ innerHeight + 'px'">
        <!-- logo -->
        <Header>
            <div class="layout_logo" v-if="diy_id == 0">
                <img src="@/assets/logo.png">
                <Icon class="cursor-p mr-24 ml-24" :class="rotateIcon" type="md-menu" size="24" @click="collapsedSider"></Icon>
            </div>
            <div class="layout_nav" v-if="diy_id == 0">
                <div @click="goModal(1)">
                    <div class="nav_div" v-if="!news_count">
                        <img src="@/assets/notice.png">
                    </div>
                    <div class="nav_div" v-else>
                        <img src="@/assets/notice-active.png">
                        <div class="notice_position">{{news_count > 99 ? '99+' : news_count}}</div>
                    </div>
                </div>
                <div class="nav_div">
                    <img class="nav_portrait" src="@/assets/head_portrait.png" @click="goModal(2)">
                    <div class="nav_txt" @click="goModal(2)">{{ user }}</div>
                </div>
                <div class="nav_div" @click="goLogout">
                    <img class="width_24 mr-12" src="../../assets/shutdown.png">
                    <div>安全弹出</div>
                </div>
            </div>
        </Header>
        <!-- 动态菜单 -->
        <Layout>
            <Sider class="sider_div" :style="'height:' + (innerHeight - 64) + 'px;'" v-if="diy_id == 0" ref="sides" hide-trigger collapsible :collapsed-width="78" v-model="isCollapsed">
                <Menu :class="menuitemClasses" :active-name="String($route.name)" ref="menu" theme="light" width="auto" :open-names="openNames">
                    <div v-for="(item, index) in muen" :key="index">
                        <template v-if="item.children">
                            <Submenu v-if="!isCollapsed" :name="item.name">
                                <template slot="title">
                                    <div class="template_div" @mouseover="changeImage(item)" @mouseout="resetImage">
                                        <img class="margin_right_5" :src="currentImage(item)">
                                        <span>{{ item.title }}</span>
                                    </div>
                                </template>
                                <MenuItem v-for="(child, i) in item.children" :key="i" :name="child.name" :to="child.path">
                                    <div>{{ child.title }}</div>
                                </MenuItem>
                            </Submenu>
                            <!-- collapsible -->
                            <Tooltip v-else placement="right" theme="light" transfer>
                                <MenuItem :name="item.name">
                                    <img :src="item.icon">
                                    <span>{{ item.title }}</span>
                                </MenuItem>
                                <div slot="content">
                                    <MenuItem v-for="(child, i) in item.children" :key="i" :name="child.name" :to="child.path">{{ child.title }}</MenuItem>
                                </div>
                            </Tooltip>
                        </template>
                        <template v-else>
                            <MenuItem :name="item.name" :to="item.path">
                                <div class="template_div" @mouseover="changeImage(item)" @mouseout="resetImage">
                                    <img class="margin_right_5" :src="currentImage(item)">
                                    <span>{{ item.title }}</span>
                                </div>
                            </MenuItem>
                        </template>
                    </div>
                </Menu>
            </Sider>
            <!-- 页面主体 -->
            <Layout :style="'height:' + (innerHeight - 64) + 'px;padding: 24px'">
                <!-- v-if -->
                <Breadcrumb class="breadcrumb_title" v-if="$route.path != '/admin' && $route.path != '/admin/formwork/query' && $route.path != '/admin/formwork/editDiy'">
                    <BreadcrumbItem v-for="(item, index) in $route.matched.slice(1)" :key="index">
                        <span class="cursor-p" v-if="item.meta.title == '应用组件' && $route.path != '/admin/assembly'" @click="goAssembly">应用组件</span>
                        <span v-else>{{ item.meta.title }}</span>
                    </BreadcrumbItem>
                </Breadcrumb>
                <div class="breadcrumb_title" v-if="$route.path == '/admin/formwork/query'">
                    <Breadcrumb>
                        <BreadcrumbItem v-for="(item, index) in $route.matched.slice(1)" :key="index">{{item.meta.title}}</BreadcrumbItem>
                    </Breadcrumb>
                    <div class="breadcrumb_tail">入口链接：
                        <span class="t-color cursor-p" @click="goCopy">{{config.apiUrl + '/query?id=' + admin_id}}</span>
                        <Icon class="cursor-p" type="md-copy" color="#FF761D" @click="goCopy"/>
                    </div>
                </div>
                <Content>
                    <!-- 子页面 -->
                    <router-view></router-view>
                </Content>
            </Layout>
        </Layout>

        <!-- 账户信息/防伪预警 -->
        <Modal v-model="modals" :title="modalTitle" :width="modalWidth" :mask-closable="false">
            <div>
                <template v-if="modalID == 1">
                    <div class="flex-sb">
                        <div class="mr-24 modal-box">
                            <Select class="w200 mr-24 mb-12" v-model="storePramsModal.type" clearable filterable placeholder="请选择">
                                <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                            <Select class="w200 mr-24 mb-12" v-model="storePramsModal.status" clearable filterable placeholder="请选择">
                                <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                            <Input class="w200 mr-24 mb-12" type="text" v-model="storePramsModal.qrcode_number" placeholder="请输入溯源码编码"></Input>
                            <DatePicker class="w200 mr-24 mb-12" type="daterange" split-panels placement="bottom-start" placeholder="选择日期" separator=" 至 " @on-change="changeDate"></DatePicker>
                        </div>
                        <div class="modal-btn">
                            <Button class="mb-12 read-all-btn" @click="goReadAll">标记所有为已读</Button>
                            <Button class="theme-bg ml-24 mb-12 search-btn" icon="ios-search" type="warning" @click="goSearch">确认搜索</Button>
                        </div>
                    </div>
                    <Table ref="selection" :columns="columnsModal" :data="dataModal" border @on-selection-change="changeSelection">
                        <template slot-scope="{ index }" slot="id">
                            <div>{{ index + 1 }}</div>
                        </template>
                        <template slot-scope="{ row }" slot="title">
                            <div>{{row.title}}</div>
                        </template>
                        <template slot-scope="{ row }" slot="status">
                            <div class="t-color" v-if="row.status == 1">未读</div>
                            <div v-else-if="row.status == 2">已读</div>
                        </template>
                        <template slot-scope="{ row }" slot="operate">
                            <div class="flex-sa">
                                <Button type="success" ghost label="small" @click="goModal(3, row)">详情</Button>
                                <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                            </div>
                        </template>
                    </Table>
                    <div class="page_div">
                        <div>
                            <Checkbox class="mr-24 ml-24" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                            <Button type="error" ghost label="large" @click="goDel(0)">删除</Button>
                        </div>
                        <Page :current="storePramsModal.page" :page-size="storePramsModal.limit" :total="totalModal" show-elevator show-total @on-change="pageChangeModal"/>
                    </div>
                </template>
                <template v-if="modalID == 2">
                    <Form :model="formItem" label-position="right" :label-width="100" :rules="ruleValidate">
                        <FormItem label="账户名称：" prop="user">
                            <Input type="text" v-model="formItem.user" placeholder="请输入账户名称"></Input>
                        </FormItem>
                        <FormItem label="登录密码：">
                            <Input type="password" v-model="formItem.password" placeholder="请输入登录密码"></Input>
                        </FormItem>
                        <FormItem label="手机号：" prop="phone">
                            <Input type="text" v-model="formItem.phone" placeholder="请输入手机号"></Input>
                        </FormItem>
                    </Form>
                </template>
            </div>
            <div slot="footer">
                <template v-if="modalID == 2">
                    <Button @click="removeModal">取消修改</Button>
                    <Button class="theme-bg" type="warning" @click="submitModal">确定修改</Button>
                </template>
            </div>
        </Modal>
        <!-- 预警详情 -->
        <Modal v-model="info_modal" title="防窜货预警详情" width="700" :mask-closable="false">
            <div>
                <div>
                    <div class="detail_header">
                        <img class="width_22 mr-24" src="../../assets/information.png">
                        <div>预警原因：当前产品<span style="color: #FB5451;">首次查询区域与指定代理（代理商）销售区域不一致</span>，有相关窜货嫌疑，请核实</div>
                    </div>
                    <div class="detail_content">
                        <div>
                            <div class="detail_div"><div class="detail_left">产品名称:</div><div class="ta-l">{{detailData.product_name}}</div></div>
                            <div class="detail_div"><div class="detail_left">产品规格:</div><div class="ta-l">{{detailData.specs}}</div></div>
                            <div class="detail_div"><div class="detail_left">关联溯源码编码:</div><div class="ta-l">{{detailData.qrcode_number}}</div></div>
                            <div class="detail_div"><div class="detail_left">所属代理:</div><div class="ta-l">{{detailData.agent_name}}</div></div>
                        </div>
                        <div>
                            <div class="detail_div"><div class="detail_left">所属批次:</div><div class="ta-l">{{detailData.batch}}</div></div>
                            <div class="detail_div"><div class="detail_left">商品ID:</div><div class="ta-l">{{detailData.id}}</div></div>
                            <div class="detail_div"><div class="detail_left">查询次数:</div><div class="ta-l">{{detailData.count}}</div></div>
                            <div class="detail_div"><div class="detail_left">代理区域:</div><div class="ta-l">
                                {{detailData.region[0] ? detailData.region[0].province : '-'}}{{detailData.region[0] ? detailData.region[0].city : '-'}}{{detailData.region[0] ? detailData.region[0].county : '-'}}
                            </div></div>
                        </div>
                    </div>
                </div>
                <Table :columns="columnsDetail" :data="dataDetail" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="name">
                        <div class="flex-c">
                            <img class="width_16 mr-12" v-if="row.drive == 'ios'" src="../../assets/ios.png">
                            <img class="width_16 mr-12" v-if="row.drive == 'android'" src="../../assets/android.png">
                            <div>{{row.name}}</div>
                        </div>
                    </template>
                </Table>
                <div class="mt-24 ta-r">
                    <Page :current="storePramsDetail.page" :page-size="storePramsDetail.limit" :total="totalDetail" show-elevator show-total @on-change="pageChangeDetail"/>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 联系客服 -->
        <ContactButton v-if="$route.path != '/admin/formwork/editDiy'" :type="2" />
    </Layout>
</template>

<script>
import { 
    logout, 
    home_news_list, 
    home_delete_info, 
    home_news_info, 
    other_citys, 
    home_news_count, 
    account_modify_info,
    home_read_all,
} from '@/api/index';
import { windowsRise } from '@/utils/dom';
import config from "@/config/index";
import { getCookies, removeCookies } from "@/utils/helper";
import ContactButton from '@/components/ContactButton/ContactButton.vue';
export default {
    components: { ContactButton },
    data(){
        return{
            imageValue: "",
            imgConfig: config.apiUrl + '/',
            uploadImg: config.apiUrl + "/adminapi/file_upload",
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            innerHeight: 0,
            diy_id: 0,
            user: "",
            phone: "",
            id: "",
            admin_id: '',
            openNames: [],
            news_count: 0,  //未读总数
            modals: false,
            info_modal: false,
            formItem: {
                user: '',
                password: '',
                phone: '',
            },
            isCollapsed: false,
            modalTitle: "",
            modalID: "",
            modalWidth: "",
            storePramsModal: {
                page: 1,
                limit: 10,
                start_date: "",
                end_date: "",
                type: "",
                status: "",
                qrcode_number: "",
            },
            totalModal: 0,
            columnsModal: [
                { type: 'selection', width: 60, align: 'center' },
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "消息内容", key: "content", align: "center" },
                { title: "消息类型", slot: "title", align: "center" },
                { title: "关联溯源码编码", key: "qrcode_number", align: "center" },
                { title: "时间", key: "handle_time", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "170px",
                },
            ],
            dataModal: [],
            typeList: [
                { id: -1, name: "全部" },
                { id: 1, name: "防伪预警" },
                { id: 2, name: "防窜货预警" },
            ],
            statusList: [
                { id: -1, name: "全部" },
                { id: 1, name: "未读" },
                { id: 2, name: "已读" },
            ],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            templateID: "",
            storePramsDetail: {
                page: 1,
                limit: 10,
                id: "",
            },
            totalDetail: 0,
            columnsDetail: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "查询次数", key: "product_query_count", align: "center" },
                { title: "查询时间", key: "handle_time", align: "center" },
                { title: "查询会员", slot: "name", align: "center" },
                { title: "查询人员定位信息", key: "address", align: "center" },
                { title: "IP", key: "ip", align: "center" },
            ],
            dataDetail: [],
            detailData: {
                product_name: "",
                batch: "",
                specs: "",
                id: "",
                qrcode_number: "",
                count: "",
                agent_name: "",
                region: [],
            },
            ruleValidate: {
                user: [
                    { required: false, message: '请输入账户名称', trigger: 'blur' },
                ],
                phone: [
                    { required: false, message: '请输入手机号', trigger: 'blur' },
                ],
            },
        }
    },
    computed: {
        muen() {
            return this.$store.state.menus;
        },
        rotateIcon () {
            return [
                'menu_icon',
                this.isCollapsed ? 'rotate_icon' : ''
            ];
        },
        menuitemClasses () {
            return [
                'menu_item',
                this.isCollapsed ? 'collapsed_menu' : ''
            ]
        },
    },
    created(){
        this.user = localStorage.getItem('user');
        this.phone = localStorage.getItem('phone');
        this.id = localStorage.getItem('id');
        this.admin_id = localStorage.getItem('admin_id');
        if(!localStorage.getItem('cityList')){
            this.getCity();
        };
    },
    mounted(){
        this.restHeight();
        windowsRise(window, this.restHeight);
        this.selectMenu();
        this.getNewsCount();
    },
    watch: {
        '$route.path'() {
            this.selectMenu();
        },
    },
    methods:{
        currentImage(item) {
            // 确保返回的是图片的URL
            if(this.imageValue == item.name){
                return item.select_icon;
            }else {
                return item.name == this.$route.name ? item.select_icon : item.icon;
            }
        },
        changeImage(item) {
            this.imageValue = item.name;
        },
        resetImage() {
            this.imageValue = '';
        },
        // 获取预警信息未读总数
        getNewsCount(){
            home_news_count().then((res) => {
                this.news_count = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getCity(){
            other_citys().then(res => {
                localStorage.setItem('cityList', JSON.stringify(res.data));
            })
        },
        getList() {
            home_news_list(this.storePramsModal).then((res) => {
                this.dataModal = res.data.data;
                this.totalModal = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goSearch(){
            this.getList();
        },
        pageChangeModal(index) {
            this.storePramsModal.page = index;
            this.getList();
        },
        pageChangeDetail(index){
            this.storePramsDetail.page = index;
            this.getNewsInfo();
        },
        changeDate(e){
            if(e[0]){
                this.storePramsModal.start_date = e[0];
                this.storePramsModal.end_date = e[1];
            }else {
                this.storePramsModal.start_date = '';
                this.storePramsModal.end_date = '';
            }
        },
        goDel(index, row){
            if(index == 0 && this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '是否确认删除防伪预警消息，删除后将无法恢复！',
                onOk: () => {
                    if(index == 0){
                        var del_id = [];
                        this.delData.forEach(item => {
                            del_id.push(item.id)
                        });
                        this.del_id = del_id.join(',');
                        home_delete_info({ id: this.del_id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }else if(index == 1){
                        home_delete_info({ id:row.id }).then(res=>{
                            that.getList();
                            this.$Message.success(res.msg);
                        }).catch(res=>{
                            this.$Message.error(res.msg);
                        })
                    }
                },
                onCancel: () => {
                }
            }); 
        },
        collapsedSider () {
            this.$refs.sides.toggleCollapse();
        },
        /**修改高度 */
        restHeight(){
            this.innerHeight =  window.innerHeight - 2;
        },
        /**修改导航展开样式 */
        selectMenu(){
            // DIY导航展开关闭
            if(this.$route.query.diy_id){
                this.diy_id = this.$route.query.diy_id;
            }else{
                this.diy_id = 0;
                this.openNames = [this.$route.name.split('-')[0]];
                this.$nextTick(()=>{
                    this.$refs.menu.updateOpened();
                })
            }
        },
        goLogout(){
            logout().then((res) => {
                this.$Message.success(res.msg);
                localStorage.clear();
                removeCookies("pcToken");
                this.$router.push({ path: "/" });
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goModal(index, row){
            if(index == 1){
                this.modalID = index;
                this.modalTitle = "防伪预警";
                this.modalWidth = "80";
                this.getList();
                setTimeout(() => {
                    this.modals = true;
                }, 500);
            }else if(index == 2){
                this.modalID = index;
                this.modalTitle = "账户信息";
                this.modalWidth = "500";
                this.formItem.user = this.user;
                this.formItem.phone = this.phone;
                this.modals = true;
            }else if(index == 3){
                this.storePramsDetail.id = row.id;
                this.getNewsInfo();
                setTimeout(() => {
                    this.info_modal = true;
                    if(row.status == 1){
                        this.getList();
                        this.getNewsCount();
                    }
                }, 300);
            }
        },
        getNewsInfo(){
            home_news_info(this.storePramsDetail).then((res) => {
                this.dataDetail = res.data.list.data;
                this.totalDetail = res.data.list.total;
                this.detailData.product_name = res.data.infos.qrcode.product.product_name;
                this.detailData.batch = res.data.infos.qrcode.batch.batch_name;
                this.detailData.specs = res.data.infos.qrcode.product.specs;
                this.detailData.id = res.data.infos.qrcode.product.id;
                this.detailData.qrcode_number = res.data.infos.qrcode.qrcode_number;
                this.detailData.count = res.data.infos.qrcode.agent.agent_name;
                this.detailData.agent_name = res.data.infos.qrcode.agent.agent_name;
                this.detailData.region = res.data.infos.qrcode.agent.region;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        removeModal(){
            this.modals = false;
        },
        submitModal(){
            account_modify_info(this.formItem).then( res => {
                this.modals = false;
                this.goLogout();
            }).catch(res=>{
                this.$Message.error(res.msg);
            });
        },
        goCopy(){
            let text = this.config.apiUrl + '/query?id=' + this.admin_id;
            this.$copyText(text).then(
                (e) => {
                    this.$Message.success({
                        background: true,
                        content: "复制成功",
                        closable: true,
                    });
                },
                (err) => {
                    alert("复制失败");
                    console.log(err);
                }
            );
        },
        // selection
        changeSelection(e){
            this.delData = e;
            if(this.dataModal.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            };
        },
        handleSelectAll(e){
            if(e == true){
                this.delData = this.dataModal;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            };
        },
        // 跳转应用组件
        goAssembly(){
            this.$router.push({ path: "/admin/assembly" });
        },
        goReadAll(){
            home_read_all().then( res => {
                this.getList();
                this.getNewsCount();
                this.$Message.success(res.msg);
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
    }
}
</script>

<style scoped>
.width_16 {
    width: 16px;
    height: 16px;
}
.detail_header {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #484E66;
}
.width_22 {
    width: 22px;
    height: 22px;
}
.detail_content {
    margin: 24px 0;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-around;
}
.detail_div {
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.detail_left {
    margin-right: 24px;
    width: 110px;
    text-align: right;
}
.page_div {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.sider_div {
    border-top: 1px solid #fff;
    margin: -1px 0 0 0;
    background: #fff;
    overflow: auto;
    scrollbar-width: none; /* 针对Firefox */
}
.sider_div::-webkit-scrollbar {
    display: none; /* 针对Chrome, Safari和Opera等Webkit浏览器 */
}
.menu_icon {
    transition: all .3s;
}
.rotate_icon {
    transform: rotate(-90deg);
}
.menu_item span {
    display: inline-block;
    overflow: hidden;
    width: 100px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width .2s ease .2s;
}
.menu_item i{
    transform: translateX(0px);
    transition: font-size .2s ease, transform .2s ease;
    vertical-align: middle;
    font-size: 16px;
}
.collapsed_menu span{
    width: 0px;
    transition: width .2s ease;
}
.collapsed_menu i{
    transform: translateX(5px);
    transition: font-size .2s ease .2s, transform .2s ease .2s;
    vertical-align: middle;
    font-size: 22px;
}
.width_24 {
    width: 24px;
    height: 24px;
}
.nav_portrait {
    margin-left: 36px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
}
.nav_txt {
    margin: 0 12px;
    padding-right: 24px;
    height: 20px;
    line-height: 20px;
}
.nav_div {
    display: flex;
    align-items: center;
    position: relative;
}
.layout_logo {
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
}
.layout_nav {
    float: right; 
    display: flex;
    align-items: center;
    color: #484E66;
    cursor: pointer;
}
.notice_position {
    position: absolute;
    top: -10px;
    right: -22px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    background: #FF6161;
    border-radius: 50%;
    overflow: hidden;
    white-space: nowrap;
}
.breadcrumb_title {
    margin-bottom: 24px;
    padding: 24px;
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(82,102,136,0.1);
    border-radius: 5px;
}
.breadcrumb_title:before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #FF761D;
    border-radius: 5px;
    margin-right: 5px;
}
.breadcrumb_tail {
    flex: 1;
    text-align: right;
}
.ivu-layout-header {
    padding: 0 24px;
    background-color: #fff;
    position: relative;
    z-index: 99;
}
.ivu-layout-header:after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #dcdee2;
}
::v-deep .layout_logo .ivu-select-selection {
    border: none;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #FF761D;
    color: #FF761D;
}
.ivu-menu-light {
    background-color: #fff;
    color: #333333;
    padding: 5px;
}
.ivu-menu-item {
    color: #333333;
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    content: none;
}
.ivu-menu-item:hover {
    color: #FF761D !important;
}
::v-deep .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #FF761D !important;
}
.template_div {
    display: flex;
    align-items: center;
    height: 22px;
    line-height: 22px;
}
.margin_right_5 {
    margin: 0 5px 0 0;
}
.modal-box {
    padding-bottom: 0 !important;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.modal-btn {
    display: flex;
    flex-direction: row; /* 默认水平排列 */
}

@media (max-width: 1300px) {
    .modal-btn {
        flex-direction: column; /* 垂直排列 */
    }
    .read-all-btn {
        order: 2; /* 显示在下 */
    }
    .search-btn {
        order: 1; /* 显示在上 */
    }
}
</style>